import { gql } from 'urql';

const UPDATE_OBJECTIVE_FILE = gql`
  mutation UpdateObjectiveFile(
    $fileId: Int!
    $_set: objective_files_set_input!
    $id: Int!
    $activity: String
    $timestamp: bigint
    $userId: Int
  ) {
    update_objective_files_by_pk(pk_columns: { id: $fileId }, _set: $_set) {
      id
    }

    insert_objectives_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default UPDATE_OBJECTIVE_FILE;
